import { forwardRef, useMemo } from 'react';
import { generatePeriods } from '../data/generatePeriods';
import { LegacySelectProps, Select } from './Select';
import { useController } from 'react-hook-form';
import { SelectOption } from '../models/SelectOption';
import { Periodo } from 'shared/models/Periodo';

type PeriodSelectProps = Omit<LegacySelectProps, 'options'>;

const periods = generatePeriods();

export const PeriodSelect = forwardRef<any, PeriodSelectProps>(
  ({ label, name, registerOptions }: PeriodSelectProps, ref) => {
    const {
      field: { value, onChange },
      fieldState: { invalid },
      formState: { isSubmitted },
    } = useController({
      name,
      rules: registerOptions,
      defaultValue: null,
    });

    const selectedOption = useMemo(() => {
      return periods.find((option) => option.value.equals(value)) || periods[0];
    }, [value]);

    const handleSelection = (option: SelectOption<Periodo>) => {
      onChange(option?.value || null);
    };

    return (
      <Select
        name="cuenta_selector"
        label={label}
        options={periods}
        value={selectedOption}
        onChange={handleSelection}
        classNames={{
          control: () => {
            if (!isSubmitted) {
              return '';
            }
            return invalid ? 'state-error' : 'state-valid';
          },
        }}
      />
    );
  },
);
